<template>

	<section v-if="isInquiryModal">

		<div class="back_lay" @click="closeModal"></div>

		<!-- Modal -->
		<div class="modal modal_shadow">

			<div class="modal__header clear_fix">
				<user-avatar :data="client" :set-class="'modal__avatar'"></user-avatar>
				<div class="modal__title">
					{{client.last_name}} {{client.first_name | one}}{{client.middle_name | one}}
				</div>
			</div>

			<!-- Outer -->
			<div class="modal__outer">

				<div class="modal__inner">
					<ul class="modal__list">
						<li class="modal__list-item">
							<span class="span-text t-right">Телефон:</span><span class="span-text t-left">+{{client.phone}}</span>
						</li>
						<li class="modal__list-item">
							<span class="span-text t-right">Дата/Время:</span><span
							class="span-text t-left">{{[inquiry.begin, 'X'] | moment('DD.MM.YY/HH:mm')}}</span>
						</li>
						<li class="modal__list-item">
							<span class="span-text t-right">Статус:</span><span
							class="span-text t-left">{{inquiry.status | status}}</span>
						</li>
						<li class="modal__list-item" v-show="inquiry.description">
							<span class="span-text t-right">Комментарий:</span>
						</li>
					</ul>

					<p class="modal__basic-text modal__basic-text_comment">
						{{inquiry.description}}
					</p>

				</div>
				<div class="modal__inner  modal__inner_mb">
					<div class="modal__btn-wrap">
						<button class="modal__btn modal__btn_decor"
										@click="createVisit(inquiry)">
							Создать визит
						</button>
						<button class="modal__btn modal__btn_gray modal__btn_decor"
										@click="cancelInquiry(inquiry)">
							Отменить
						</button>
					</div>
				</div>
			</div>
			<!-- Outer End -->

			<i class="modal__icon_close icon ion-close trans" @click="closeModal"></i>
		</div>
		<!-- Modal End -->
	</section>
</template>

<script>
	export default {
		name: 'InquiryModal',
		computed: {
			clinicId() {
				return this.$route.query.clinic || this.$storage.get('clinic')
			},
			clinic() {
				return this.$store.state.auth.clinic
			},
			userId() {
				return this.$store.state.auth.user._id
			},
			client() {
				return this.inquiry.user
			}
		},
		mounted() {
			this.$event.connect('openInquiryModal', inquiry => {
				this.inquiry = inquiry
				this.doctor = inquiry.worker
				this.isInquiryModal = true
				this.isDoctor = (inquiry.user._id !== this.userId)
			})
		},
		beforeDestroy() {
			this.$event.disconnect(['openInquiryModal'])
		},
		data () {
			return {
				isInquiryModal: false,
				isDoctor: false,
				inquiry: {},
				constNames: {
					"declared": 'Создана',
					"processed": 'Обработана',
					"disapproved": 'Отклонена'
				}
			}
		},
		methods: {
			createVisit(inquiry) {
				this.$event.send('sendInquiry', inquiry)
				this.closeModal()
			},
			cancelInquiry(inquiry) {
				inquiry.status = 'disapproved'

				this.$store.dispatch('inquiry/update', inquiry).then(() => {
					this.closeModal()
					this.$event.send('updateInquiryList', inquiry.worker._id)
				})
			},
			showCard(id) {
				this.$router.push({
					name: 'Card',
					query: {patient: id}
				})

				this.closeModal()
			},
			closeModal (save) {
				this.isInquiryModal = false

				if (!save) {
					this.isInquiryModal = false
					this.isDoctor = false

					this.patient = {}
					this.users = []
					this.inquiry = {}
				}
			}
		}
	}
</script>

<style scoped>
	.modal {
		z-index: 510;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background: white;
	}
</style>



// WEBPACK FOOTER //
// InquiryModal.vue?68d76880